import { StandardBranchContainerImpl } from './standard_branch_container/container';
import { ITenantBasicData, StandardBranchManager } from './standard_branch_manager';
import { STANDARD_BRANCH_MANAGER } from './types/constants';
import { EN_STANDARD_BRANCH_NAMESPACE } from './types/interface';

let container: StandardBranchContainerImpl;
let standardBranchManager: StandardBranchManager;

export const initStandardBranchManager = (params: ITenantBasicData): void => {
  standardBranchManager = new StandardBranchManager();
  standardBranchManager.initTenant(params);

  container = new StandardBranchContainerImpl();
  container.register({
    namespace: EN_STANDARD_BRANCH_NAMESPACE.DEFAULT,
    value: standardBranchManager,
    symbol: STANDARD_BRANCH_MANAGER,
  });
  (window as any).sbContainer = container;
};

export const getStandardBranchManager = (): StandardBranchManager => {
  if (!standardBranchManager) {
    throw new Error('stanadardBranch未初始化');
  }
  return standardBranchManager;
};

export const getStandardBranchContainer = (): StandardBranchContainerImpl => {
  if (!container) {
    throw new Error('container未初始化');
  }
  return container;
};
